import { bugsnagNotifyError } from "./bugsnag";
import analytics from "./analytics";

export function reportError(error, metaData) {
  bugsnagNotifyError(error, metaData);
  analytics.trackEvent(error.message, metaData);
  console.log(error, metaData);
}
